<template>
  <div class="loading">
    <icon-loading-circle class="loading__circle"/>
  </div>
</template>

<script>
import IconLoadingCircle from '@/mikan/_shared/components/atoms/icons/IconLoadingCircle.vue';

export default {
  components: {
    IconLoadingCircle,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';
@import '~@/mikan/_shared/base/mixins';

.loading {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: $color-white;
  opacity: 0.5;

  &__circle {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: px-to-rem(80px);
    transform: translate(-50%, -50%);
  }
}
</style>
